import { Feather } from "lucide-react";
import { assetUrl } from "@/lib/api";

export const PoemOfTheMonth = ({ s }) => {
  if (!s.potm_enabled || !s.potm_text) return null;
  return (
    <section className="bg-quartz text-ink relative overflow-hidden" data-testid="home-poem-of-the-month">
      <div className="container-mas py-16 sm:py-20 grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        {s.potm_image && (
          <div className="lg:col-span-4 lg:col-start-2">
            <div className="relative shadow-[8px_8px_0_#1D1D1B] max-w-[260px] sm:max-w-[300px] mx-auto lg:mx-0">
              <img src={assetUrl(s.potm_image)} alt={s.potm_poet} className="w-full aspect-[4/5] object-cover" loading="lazy" data-testid="potm-image" />
              {s.potm_month && <span className="absolute top-4 left-4 bg-ink text-shell font-display text-sm px-3 py-1" data-testid="potm-month-badge">{s.potm_month}</span>}
            </div>
          </div>
        )}
        <div className={s.potm_image ? "lg:col-span-7" : "lg:col-span-8 lg:col-start-3"}>
          <p className="font-mono text-[11px] uppercase tracking-[0.22em] flex items-center gap-2"><Feather className="w-4 h-4" />poem of the month{!s.potm_image && s.potm_month ? ` · ${s.potm_month}` : ""}</p>
          {s.potm_title && <h2 className="h-section mt-4" data-testid="potm-title">{s.potm_title}</h2>}
          <blockquote className="mt-6 border-l-4 border-ink pl-5 sm:pl-7 text-lg sm:text-xl leading-relaxed whitespace-pre-line" data-testid="potm-text">{s.potm_text}</blockquote>
          {s.potm_poet && (
            <div className="mt-8" data-testid="potm-poet">
              <p className="font-display text-2xl">— {s.potm_poet}</p>
              {s.potm_poet_note && <p className="text-sm uppercase tracking-wider mt-1">{s.potm_poet_note}</p>}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
